// extracted by mini-css-extract-plugin
export default {"image":"Slider_image__uV7aW","carouserButton":"Slider_carouserButton__S0jkV","buttons":"Slider_buttons__Gb4V0"};